import { rem, stripUnit } from 'polished'
import { mapObjIndexed } from 'ramda'

import theme from 'theme'

/** help with odd window size to fit all three tier cards */
const newBreakpoints = Object.assign({}, theme.breakpoints, {
  mid: 890,
  md: 891,
})

const flexboxgrid = Object.assign({}, theme.flexboxgrid, {
  breakpoints: mapObjIndexed(
    (breakpoint) => stripUnit(rem(breakpoint)),
    newBreakpoints,
  ),
})

export default Object.assign({}, theme, {
  breakpoints: newBreakpoints,
  flexboxgrid,
})
